import { render, staticRenderFns } from "./CheckboxesInput.vue?vue&type=template&id=71ea8e43&"
import script from "./CheckboxesInput.vue?vue&type=script&lang=js&"
export * from "./CheckboxesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ea8e43')) {
      api.createRecord('71ea8e43', component.options)
    } else {
      api.reload('71ea8e43', component.options)
    }
    module.hot.accept("./CheckboxesInput.vue?vue&type=template&id=71ea8e43&", function () {
      api.rerender('71ea8e43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/CheckboxesInput.vue"
export default component.exports